// Define the types for headers
type Header = {
  key: string;
  label: string;
  sortable?: boolean;
  style?: React.CSSProperties;
  isNumeric?: boolean;
};

// Define the headers for the User table
export const USER_HEADERS: Header[] = [
  {
    key: "username",
    label: "User Name",
    sortable: true,
    style: { width: "14%" },
  },
  {
    key: "userfullname",
    label: "Full Name",
    sortable: true,
    style: { width: "14%" },
  },
  { key: "emailid", label: "Email", sortable: true, style: { width: "14%" } },
  {
    key: "usertype",
    label: "User Type",
    sortable: true,
    style: { width: "14%" },
  },
  {
    key: "department",
    label: "Department",
    sortable: true,
    style: { width: "14%" },
  },
  {
    key: "webrole",
    label: "Web Role",
    sortable: true,
    style: { width: "16%" },
  },
  {
    key: "currencyType",
    label: "Currency Type",
    sortable: true,
    style: { width: "16%" },
  },
  {
    key: "isActiveDetails",
    label: "Is Active",
    style: { alignItems: "center", width: "7%" },
  },
  {
    key: "actions",
    label: "Action",
    style: { textAlign: "center", width: "7%" },
  },
];

// Define the headers for the Login Device table
export const LOGIN_DEVICE_HEADERS: Header[] = [
  { key: "deviceid", label: "Device ID" },
  { key: "devicename", label: "Device Name" },
  { key: "lastlogindatetime", label: "Last Login Date & Time" },
];
